import { Injectable } from '@angular/core';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { PassageOrderLkFindManyQueryInterface } from '@zaoblako/shared/modules/pacs/dtos/passage-order-lk/passage-order-lk-find-many-query.dto';
import type { PassageOrderLkFindInterface } from '@zaoblako/shared/modules/pacs/dtos/passage-order-lk/passage-order-lk-find.dto';
import type { PassageOrderLkPageInterface } from '@zaoblako/shared/modules/pacs/dtos/passage-order-lk/passage-order-lk-page.dto';
import type { CardDescriptorInterface } from '@zaoblako/shared/common/dtos/card/card-descriptor.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonalAccountPassageOrderService extends BaseService {
  protected baseUrl = '/personal-account/pacs/passage-order';

  public getCardDescriptor(orderId?: number): Observable<CardDescriptorInterface> {
    return this.http.get<CardDescriptorInterface>(`${this.baseUrl}/card-descriptor`, {
      params: orderId ? { orderId } : {}
    });
  }

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findMany(queryParams: PassageOrderLkFindManyQueryInterface): Observable<PassageOrderLkPageInterface> {
    return this.http.get<PassageOrderLkPageInterface>(`${this.baseUrl}/items`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public restoreOne(id: number): Observable<PassageOrderLkFindInterface> {
    return this.http.post<PassageOrderLkFindInterface>(`${this.baseUrl}/${id}/restore`, {});
  }

  public getHistoryForOne(id: number, query?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: query ? this.objectToHttpParams(query) : {}
    });
  }
}
